export const allCoursesOffer = {
    // Programming
    "pgcp": {
        title: "Post Graduate in Computer Programming (PGCP)",
        description:
            "A comprehensive program covering multiple programming languages, web development, databases, and networking, with hands-on projects.",
        category: "Programming",
        duration: "18 months",
        level: "Beginner to Advanced",
        students: "350+",
        rating: 4.8,
        price: "₹55,000",
        whatIsCourse:
            "The Post Graduate in Computer Programming (PGCP) is an advanced program designed for learners who want to master multiple programming languages and technologies. The course starts with C and C++ fundamentals, progresses into Python and Java, covers web development with PHP and HTML, dives into databases with SQL Server and MySQL, introduces networking concepts, and includes Microsoft’s .NET framework. The program concludes with industry-oriented projects, ensuring students gain practical experience across different domains of software development.",
        image:
            "https://img.freepik.com/free-photo/programming-background-with-person-working-with-codes-computer_23-2150010125.jpg",
        syllabus: [
            {
                module: "Module 1: C and C++ Programming",
                topics: [
                    "C Language Basics",
                    "Control Structures, Arrays, and Pointers",
                    "Functions, Structures, and File Handling",
                    "OOP Concepts with C++",
                    "Classes, Inheritance, Polymorphism",
                    "Templates and Exception Handling"
                ]
            },
            {
                module: "Module 2: Python Programming",
                topics: [
                    "Python Basics and Syntax",
                    "Data Structures and Functions",
                    "File Handling and Modules",
                    "Object-Oriented Programming in Python",
                    "Database Connectivity",
                    "Mini Project in Python"
                ]
            },
            {
                module: "Module 3: Java Programming",
                topics: [
                    "Java Basics and JVM",
                    "Classes, Objects, and Methods",
                    "Inheritance and Interfaces",
                    "Exception Handling",
                    "Collections Framework",
                    "Multithreading",
                    "Mini Project in Java"
                ]
            },
            {
                module: "Module 4: Web Development with PHP & HTML",
                topics: [
                    "Introduction to Web Development",
                    "HTML Basics",
                    "Forms and User Input",
                    "PHP Syntax and Control Structures",
                    "PHP with MySQL",
                    "Developing Dynamic Web Pages",
                    "Mini Web Project"
                ]
            },
            {
                module: "Module 5: Databases",
                topics: [
                    "Introduction to RDBMS",
                    "SQL Basics",
                    "Working with SQL Server",
                    "Working with MySQL",
                    "Joins, Subqueries, and Views",
                    "Stored Procedures and Triggers",
                    "Database Projects"
                ]
            },
            {
                module: "Module 6: Networking",
                topics: [
                    "Networking Fundamentals",
                    "OSI and TCP/IP Models",
                    "IP Addressing and Subnetting",
                    "Client-Server Architecture",
                    "Basics of Network Security"
                ]
            },
            {
                module: "Module 7: .NET Programming",
                topics: [
                    "Introduction to C# and VB.NET",
                    "OOP Concepts in .NET",
                    "Windows Forms Development",
                    "ASP.NET Basics",
                    "Database Connectivity with ADO.NET",
                    "Mini Project in ASP.NET"
                ]
            },
            {
                module: "Module 8: Capstone Project",
                topics: [
                    "End-to-End Software Development",
                    "Team Collaboration with Git",
                    "Presentation and Documentation",
                    "Final Project Showcase"
                ]
            }
        ],
        tools: [
            "C Compiler (GCC)",
            "Code::Blocks/Dev C++",
            "PyCharm/VS Code",
            "Eclipse/NetBeans (Java)",
            "PHP & XAMPP/WAMP",
            "SQL Server",
            "MySQL Workbench",
            "Visual Studio (.NET)",
            "HTML/CSS Editors",
            "Git"
        ],
        whatYouLearn: [
            "Strong foundation in multiple programming languages (C, C++, Python, Java, PHP, C#)",
            "Object-Oriented Programming concepts across languages",
            "Web development with PHP, HTML, and ASP.NET",
            "Database management with SQL Server and MySQL",
            "Basics of networking and client-server communication",
            "Develop full-stack applications",
            "Work on individual and team projects"
        ],
        whoCanEnroll: [
            "Graduates in any discipline aiming for IT careers",
            "Computer science and IT students",
            "Aspiring software engineers and full-stack developers",
            "Networking and database enthusiasts",
            "Professionals wanting to upskill in multiple technologies"
        ],
        careerPaths: [
            "Software Developer",
            "Full Stack Developer",
            "Java/Python Developer",
            "PHP Developer",
            ".NET Developer",
            "Database Administrator",
            "Network Engineer",
            "Application Developer"
        ],
        testimonials: [
            {
                name: "Ankit Rao",
                role: "Full Stack Developer at Infosys",
                content:
                    "PGCP covered everything I needed — from C and C++ to Java, Python, PHP, and databases. The final project gave me the confidence to work in real-world environments.",
                rating: 5
            },
            {
                name: "Kavya Iyer",
                role: "Software Engineer at Capgemini",
                content:
                    "A very comprehensive program. I got exposure to multiple programming languages, networking, and database management. It helped me land my dream job.",
                rating: 5
            }
        ]
    },

    "dpp": {
        title: "Diploma in Python Programming (DPP)",
        description:
            "Learn programming fundamentals with C, explore Object-Oriented Programming using C++, and build practical projects in Python.",
        category: "Programming",
        duration: "3 months",
        level: "Beginner to Intermediate",
        students: "520+",
        rating: 4.7,
        price: "₹18,000",
        whatIsCourse:
            "The Diploma in Python Programming (DPP) course is designed to provide a strong foundation in programming through C language, advance your knowledge with Object-Oriented Programming (OOP) using C++, and finally apply your skills in Python through real-world projects. This structured pathway ensures you build strong problem-solving abilities, understand core programming concepts, and gain hands-on experience in Python development.",
        image:
            "https://webandcrafts.com/_next/image?url=https%3A%2F%2Fadmin.wac.co%2Fuploads%2FFeatures_Of_Python_1_f4ccd6d9f7.jpg&w=4500&q=90",
        syllabus: [
            {
                module: "Module 1: C Language Fundamentals",
                topics: [
                    "Introduction to Programming & C basics",
                    "Data Types, Operators, and Expressions",
                    "Control Statements (if, loops, switch)",
                    "Functions and Arrays",
                    "Pointers and Memory Management",
                    "Structures and File Handling"
                ]
            },
            {
                module: "Module 2: OOP with C++",
                topics: [
                    "Introduction to C++ & OOP concepts",
                    "Classes and Objects",
                    "Constructors and Destructors",
                    "Inheritance and Polymorphism",
                    "Encapsulation and Abstraction",
                    "Operator Overloading and Templates",
                    "Exception Handling in C++"
                ]
            },
            {
                module: "Module 3: Python Projects",
                topics: [
                    "Python Basics Overview",
                    "Working with Libraries",
                    "Automation Scripts",
                    "Data Handling with Python",
                    "Mini Project in Python",
                    "Capstone Project using Python"
                ]
            }
        ],
        tools: [
            "C Compiler (GCC/Turbo C++)",
            "Code::Blocks/Dev C++",
            "VS Code/PyCharm",
            "Python",
            "Git"
        ],
        whatYouLearn: [
            "Strong foundation in C programming",
            "Master Object-Oriented Programming concepts using C++",
            "Hands-on experience in solving problems with C and C++",
            "Implement real-world projects using Python",
            "Use Python libraries for automation and data handling",
            "Build a final project to showcase programming skills"
        ],
        whoCanEnroll: [
            "Beginners with no coding background",
            "Students pursuing computer science or IT",
            "Software development aspirants",
            "Engineering students looking for a strong foundation",
            "Anyone interested in starting a programming career"
        ],
        careerPaths: [
            "Software Developer",
            "C/C++ Programmer",
            "Python Developer",
            "Junior Software Engineer",
            "Automation Engineer",
            "Backend Developer"
        ],
        testimonials: [
            {
                name: "Arun Mehta",
                role: "Software Developer at Infosys",
                content:
                    "The course gave me a solid foundation in C and C++ before moving to Python. The Python projects made me confident in coding real-world applications.",
                rating: 5
            },
            {
                name: "Sneha Kapoor",
                role: "Intern at Wipro",
                content:
                    "I loved how the course started from C basics, then OOP in C++, and finally moved into Python projects. Very beginner-friendly yet practical.",
                rating: 4
            }
        ]
    },
    "djp": {
        title: "Diploma in Java Programming (DJP)",
        description:
            "Start with C language fundamentals, advance with Object-Oriented Programming in C++, and build robust applications using Sun Java 6.0.",
        category: "Programming",
        duration: "3 months",
        level: "Beginner to Intermediate",
        students: "480+",
        rating: 4.6,
        price: "₹20,000",
        whatIsCourse:
            "The Diploma in Java Programming (DJP) course is structured to give learners a strong programming foundation. You will begin with C language fundamentals, strengthen your knowledge with Object-Oriented Programming (OOP) in C++, and finally master Java with practical projects in Sun Java 6.0. This pathway ensures you learn core programming principles, OOP concepts, and professional Java development skills for real-world applications.",
        image:
            "https://i.pinimg.com/736x/bd/89/3a/bd893a529d494acb0977cf90413987f1.jpg",
        syllabus: [
            {
                module: "Module 1: C Language Fundamentals",
                topics: [
                    "Introduction to Programming & C basics",
                    "Data Types, Operators, and Expressions",
                    "Control Statements (if, loops, switch)",
                    "Functions and Arrays",
                    "Pointers and Memory Management",
                    "Structures and File Handling"
                ]
            },
            {
                module: "Module 2: OOP with C++",
                topics: [
                    "Introduction to C++ & OOP concepts",
                    "Classes and Objects",
                    "Constructors and Destructors",
                    "Inheritance and Polymorphism",
                    "Encapsulation and Abstraction",
                    "Operator Overloading and Templates",
                    "Exception Handling in C++"
                ]
            },
            {
                module: "Module 3: Java Programming (Sun Java 6.0)",
                topics: [
                    "Introduction to Java & JVM",
                    "Data Types, Variables, and Operators",
                    "Control Flow in Java",
                    "Classes, Objects, and Methods",
                    "Inheritance, Polymorphism & Interfaces",
                    "Exception Handling",
                    "Java Collections Framework",
                    "File Handling & I/O Streams",
                    "Multithreading in Java",
                    "Mini Project in Java",
                    "Capstone Project using Sun Java 6.0"
                ]
            }
        ],
        tools: [
            "C Compiler (GCC/Turbo C++)",
            "Code::Blocks/Dev C++",
            "Eclipse/NetBeans (for Java)",
            "Sun JDK 6.0",
            "Git"
        ],
        whatYouLearn: [
            "Strong foundation in C programming",
            "Master Object-Oriented Programming concepts using C++",
            "Develop Java programs using Sun Java 6.0",
            "Work with Java libraries and collections",
            "Implement exception handling and multithreading",
            "Build mini and capstone projects in Java"
        ],
        whoCanEnroll: [
            "Beginners with no coding background",
            "Students pursuing computer science or IT",
            "Aspiring Java developers",
            "Engineering students looking for strong programming skills",
            "Anyone interested in backend or enterprise development"
        ],
        careerPaths: [
            "Java Developer",
            "Software Engineer",
            "C/C++ Programmer",
            "Backend Developer",
            "Application Developer",
            "Junior Software Engineer"
        ],
        testimonials: [
            {
                name: "Rohit Sharma",
                role: "Java Developer at TCS",
                content:
                    "The course helped me move step by step from C to C++ and finally into Java. The Java projects gave me the confidence to start as a developer.",
                rating: 5
            },
            {
                name: "Neha Reddy",
                role: "Intern at HCL",
                content:
                    "I liked the structure – learning C and C++ first made Java concepts much easier. The Sun Java 6.0 projects were really practical.",
                rating: 4
            }
        ]
    },
    "dcp": {
        title: "Diploma in C & C++ Programming (DCP)",
        description:
            "Master the fundamentals of programming with C and advance your skills with Object-Oriented Programming in C++, including real-world projects.",
        category: "Programming",
        duration: "3 months",
        level: "Beginner to Intermediate",
        students: "450+",
        rating: 4.6,
        price: "₹15,000",
        whatIsCourse:
            "The Diploma in C & C++ Programming (DCP) course is designed to provide learners with a strong foundation in structured programming using C and advanced programming through Object-Oriented Programming (OOP) in C++. The course concludes with hands-on projects, allowing learners to apply their knowledge in solving real-world problems. By the end of this program, students will be confident in writing efficient programs and ready to pursue careers in software development.",
        image:
            "https://i.pinimg.com/736x/51/16/39/511639ed8370cb83211f49e0d8f04af2.jpg",
        syllabus: [
            {
                module: "Module 1: C Language Fundamentals",
                topics: [
                    "Introduction to Programming & C basics",
                    "Data Types, Operators, and Expressions",
                    "Control Statements (if, loops, switch)",
                    "Functions and Arrays",
                    "Pointers and Memory Management",
                    "Structures and File Handling"
                ]
            },
            {
                module: "Module 2: OOP with C++",
                topics: [
                    "Introduction to C++ & OOP concepts",
                    "Classes and Objects",
                    "Constructors and Destructors",
                    "Inheritance and Polymorphism",
                    "Encapsulation and Abstraction",
                    "Operator Overloading and Templates",
                    "Exception Handling in C++"
                ]
            },
            {
                module: "Module 3: Projects in C & C++",
                topics: [
                    "Building Console Applications",
                    "File Handling Projects",
                    "Data Structure Implementations (Stack, Queue, Linked List)",
                    "Mini Project in C",
                    "Mini Project in C++ (OOP based)",
                    "Capstone Project in C/C++"
                ]
            }
        ],
        tools: [
            "C Compiler (GCC/Turbo C++)",
            "Code::Blocks/Dev C++",
            "Visual Studio/VS Code",
            "Git"
        ],
        whatYouLearn: [
            "Write efficient programs in C",
            "Understand memory management and pointers",
            "Master Object-Oriented Programming concepts using C++",
            "Implement data structures using C and C++",
            "Work on real-world projects in C and C++",
            "Build a strong programming foundation for advanced languages"
        ],
        whoCanEnroll: [
            "Beginners with no coding background",
            "Computer science students",
            "Engineering students preparing for placements",
            "Software development aspirants",
            "Anyone wanting to master C and C++"
        ],
        careerPaths: [
            "C/C++ Programmer",
            "Software Developer",
            "System Programmer",
            "Embedded Systems Developer",
            "Game Developer (with further specialization)",
            "Junior Software Engineer"
        ],
        testimonials: [
            {
                name: "Vikram Nair",
                role: "C++ Developer at Wipro",
                content:
                    "The course gave me a strong grip on C and C++ with practical projects. It helped me clear my interviews and land a job quickly.",
                rating: 5
            },
            {
                name: "Priya Singh",
                role: "Engineering Student",
                content:
                    "Learning C first made understanding OOP in C++ much easier. The projects were fun and really improved my coding skills.",
                rating: 4
            }
        ]
    },
    "dotnet": {
        title: "Diploma in .NET Programming (.NET)",
        description:
            "Learn C# and VB.NET fundamentals and advance into building dynamic web applications with ASP.NET projects.",
        category: "Programming",
        duration: "3 months",
        level: "Beginner to Intermediate",
        students: "420+",
        rating: 4.7,
        price: "₹22,000",
        whatIsCourse:
            "The Diploma in .NET Programming (.NET) course is designed to give learners a solid understanding of Microsoft’s .NET framework. The program begins with programming fundamentals in C#, introduces VB.NET for application development, and concludes with building professional projects in ASP.NET. This step-by-step approach equips students with the skills to develop desktop and web applications using Microsoft technologies.",
        image:
            "https://images.ctfassets.net/23aumh6u8s0i/7fPg2FUAcANY1i4sWj5XyM/a816b876c6a5ea96e8ad2596397efcc1/dotnet",
        syllabus: [
            {
                module: "Module 1: Programming with C#",
                topics: [
                    "Introduction to C# and .NET Framework",
                    "Data Types, Variables, and Operators",
                    "Control Flow (if, loops, switch)",
                    "Methods and Parameters",
                    "Arrays and Collections",
                    "Exception Handling",
                    "Object-Oriented Programming in C#"
                ]
            },
            {
                module: "Module 2: Application Development with VB.NET",
                topics: [
                    "VB.NET Basics and Syntax",
                    "Working with Forms and Controls",
                    "Event-Driven Programming",
                    "Database Connectivity with ADO.NET",
                    "Error Handling and Debugging",
                    "OOP concepts in VB.NET"
                ]
            },
            {
                module: "Module 3: Web Development with ASP.NET",
                topics: [
                    "Introduction to ASP.NET and Web Forms",
                    "State Management (ViewState, Session, Cookies)",
                    "Database Integration with SQL Server",
                    "Master Pages and User Controls",
                    "Authentication and Authorization",
                    "Web Services and APIs",
                    "Mini ASP.NET Project",
                    "Capstone Project in ASP.NET"
                ]
            }
        ],
        tools: [
            "Microsoft Visual Studio",
            "C#",
            "VB.NET",
            "ASP.NET Framework",
            "SQL Server",
            "Git"
        ],
        whatYouLearn: [
            "Develop applications using C# and VB.NET",
            "Understand OOP concepts in .NET",
            "Connect applications with databases using ADO.NET",
            "Build dynamic and interactive web applications with ASP.NET",
            "Implement authentication and authorization in web apps",
            "Develop real-world .NET projects for your portfolio"
        ],
        whoCanEnroll: [
            "Beginners with programming interest",
            "Students pursuing computer science or IT",
            "Aspiring .NET developers",
            "Software development aspirants",
            "Anyone interested in Microsoft technologies"
        ],
        careerPaths: [
            ".NET Developer",
            "C# Programmer",
            "VB.NET Application Developer",
            "ASP.NET Web Developer",
            "Software Engineer",
            "Backend Developer"
        ],
        testimonials: [
            {
                name: "Rahul Verma",
                role: ".NET Developer at HCL",
                content:
                    "The course gave me hands-on experience in C#, VB.NET, and ASP.NET. The projects helped me land my first job as a .NET developer.",
                rating: 5
            },
            {
                name: "Divya Menon",
                role: "Intern at Cognizant",
                content:
                    "I liked how the course covered both desktop and web applications. The ASP.NET project was very practical and industry-relevant.",
                rating: 4
            }
        ]
    },

    //ca
    "pdca": {
        "title": "Post Diploma in Computer Application (PDCA)",
        "description":
            "Gain comprehensive knowledge in computer applications, from operating systems and office tools to hardware troubleshooting. Choose your specialization with electives in accounting & design or programming.",
        "category": "Computer Application",
        "duration": "6 months",
        "level": "Beginner to Intermediate",
        "students": "480+",
        "rating": 4.6,
        "price": "₹22,000",
        "whatIsCourse":
            "The Post Diploma in Computer Application (PDCA) is designed to provide students with a strong foundation in essential computer skills and practical knowledge. The course covers Windows operating systems, MS Office tools, and basic hardware with troubleshooting. Additionally, students can choose from two elective tracks—Elective 1: Tally.ERP 9 and DTP for business and design applications, or Elective 2: C, C++, and Python for programming and software development. With hands-on exercises and real-world tasks, learners will gain job-ready skills across multiple domains.",
        "image":
            "https://img.freepik.com/free-photo/programming-background-with-person-working-with-codes-computer_23-2150010125.jpg",
        "syllabus": [
            {
                "module": "Module 1: Fundamentals",
                "topics": [
                    "Introduction to Computers & Windows OS",
                    "MS Word, Excel, PowerPoint",
                    "MS Access (Database Basics)",
                    "Internet & Email Applications"
                ]
            },
            {
                "module": "Module 2: Hardware & Troubleshooting",
                "topics": [
                    "Computer Hardware Basics",
                    "Installation & Configuration",
                    "Networking Fundamentals",
                    "PC Maintenance & Troubleshooting"
                ]
            },
            {
                "module": "Elective 1: Business & Design",
                "topics": [
                    "Tally.ERP 9 – Accounting Basics",
                    "Inventory Management",
                    "GST & Payroll in Tally",
                    "Desktop Publishing (CorelDraw, Photoshop, PageMaker)"
                ]
            },
            {
                "module": "Elective 2: Programming",
                "topics": [
                    "Programming in C",
                    "Object-Oriented Programming in C++",
                    "Python Programming Basics",
                    "Mini Project"
                ]
            }
        ],
        "tools": [
            "Windows",
            "MS Office Suite",
            "Tally.ERP 9",
            "CorelDraw",
            "Photoshop",
            "PageMaker",
            "C/C++ Compiler",
            "Python"
        ],
        "whatYouLearn": [
            "Work confidently with MS Office applications",
            "Perform hardware installation and troubleshooting",
            "Apply accounting and inventory management in Tally",
            "Design with DTP tools for publishing",
            "Learn programming with C, C++, and Python",
            "Build real-world projects based on elective choice"
        ],
        "whoCanEnroll": [
            "Students aspiring for IT careers",
            "Office professionals seeking computer skills",
            "Accounting and finance learners",
            "Aspiring graphic designers",
            "Beginners interested in programming"
        ],
        "careerPaths": [
            "Office Executive",
            "Computer Operator",
            "Tally Operator",
            "DTP Designer",
            "Junior Programmer",
            "IT Support Executive"
        ],
        "testimonials": [
            {
                "name": "Kavita Sharma",
                "role": "Office Executive",
                "content":
                    "The PDCA course gave me the confidence to handle MS Office and Tally efficiently in my daily work.",
                "rating": 5
            },
            {
                "name": "Rohit Verma",
                "role": "Junior Programmer",
                "content":
                    "I chose the programming elective and learned C, C++, and Python. The projects helped me a lot in my career start.",
                "rating": 4
            }
        ]
    },
    "adca": {
        "title": "Advanced Diploma in Computer Application (ADCA)",
        "description":
            "Master essential computer skills including Windows, MS Office, and Internet applications. Choose a specialization with electives in Tally.ERP 9 for accounting or C & C++ for programming.",
        "category": "Computer Application",
        "duration": "3 months",
        "level": "Beginner",
        "students": "650+",
        "rating": 4.7,
        "price": "₹20,000",
        "whatIsCourse":
            "The Advanced Diploma in Computer Application (ADCA) is designed to equip learners with the essential knowledge of computer applications used in both professional and personal settings. The course covers Windows OS, MS Office tools, and Internet usage for effective productivity. Learners can choose between two elective tracks — Elective 1: Tally.ERP 9 for accounting and business management, or Elective 2: C & C++ for programming fundamentals and problem-solving skills. This program prepares students for careers in office management, IT support, accounting, or entry-level software development.",
        "image":
            "https://bvoc.kalingauniversity.ac.in/wp-content/uploads/2023/10/Computer-Application-and-Information-Technology.jpg",
        "syllabus": [
            {
                "module": "Module 1: Core Computer Skills",
                "topics": [
                    "Introduction to Computers & Windows OS",
                    "MS Word, Excel, PowerPoint",
                    "MS Access (Database Basics)",
                    "Internet & Email Applications"
                ]
            },
            {
                "module": "Elective 1: Business & Accounting",
                "topics": [
                    "Tally.ERP 9 – Basics of Accounting",
                    "Inventory Management",
                    "GST & Payroll in Tally",
                    "Generating Reports in Tally"
                ]
            },
            {
                "module": "Elective 2: Programming",
                "topics": [
                    "Programming Fundamentals with C",
                    "Control Structures & Functions",
                    "Object-Oriented Programming with C++",
                    "Mini Project in C/C++"
                ]
            }
        ],
        "tools": [
            "Windows",
            "MS Office Suite",
            "Tally.ERP 9",
            "C/C++ Compiler"
        ],
        "whatYouLearn": [
            "Work with Windows, MS Office, and Internet confidently",
            "Perform accounting and financial management in Tally",
            "Understand programming concepts with C & C++",
            "Develop problem-solving and logical thinking",
            "Prepare simple projects in business or programming"
        ],
        "whoCanEnroll": [
            "Students seeking career in IT or office administration",
            "Beginners in accounting and finance",
            "Aspiring programmers",
            "Small business owners",
            "Job seekers requiring computer literacy"
        ],
        "careerPaths": [
            "Computer Operator",
            "Office Executive",
            "Tally Operator",
            "Junior Accountant",
            "C/C++ Programmer",
            "IT Support Staff"
        ],
        "testimonials": [
            {
                "name": "Pooja Rathi",
                "role": "Tally Operator",
                "content":
                    "ADCA helped me master MS Office and Tally for my accounting job. Very practical and easy to learn.",
                "rating": 5
            },
            {
                "name": "Vikas Nair",
                "role": "Junior Programmer",
                "content":
                    "I chose the programming elective. Learning C and C++ gave me a solid foundation for my software career.",
                "rating": 4
            }
        ]
    },
    "dca": {
    "title": "Diploma in Computer Application (DCA)",
    "description":
        "Learn essential computer skills with a strong focus on office applications, basic programming, and IT fundamentals. This beginner-friendly course is ideal for students and professionals who want to gain practical computer knowledge.",
    "category": "Computer Application",
    "duration": "3 months",
    "level": "Beginner",
    "students": "720+",
    "rating": 4.5,
    "price": "₹18,000",
    "whatIsCourse":
        "The Diploma in Computer Application (DCA) is designed to provide students with practical knowledge in computer fundamentals, MS Office, internet applications, database basics, and an introduction to programming. Unlike PDCA, this course focuses only on core modules without electives. Students will learn essential IT skills to become job-ready for office, IT support, and entry-level technical roles.",
    "image":
        "https://media.istockphoto.com/id/629286010/photo/programming-code-abstract-technology-background-of-software-deve.jpg?s=612x612&w=0&k=20&c=yDR4ksPb7-wGl724xxEjbzpFbQd-DEdxwLiJicqNpcM=",
    "syllabus": [
        {
            "module": "Module 1: Fundamentals of Computers",
            "topics": [
                "Introduction to Computers & Windows OS",
                "MS Word, Excel, PowerPoint",
                "MS Access (Database Basics)",
                "Internet & Email Applications"
            ]
        },
        {
            "module": "Module 2: IT Tools & Productivity",
            "topics": [
                "Advanced Excel (Formulas & Charts)",
                "Presentations & Documentation",
                "Basic Graphic Tools (Paint, Canva)",
                "File Management & Cloud Storage"
            ]
        },
        {
            "module": "Module 3: Hardware & Networking Basics",
            "topics": [
                "Computer Hardware Overview",
                "Installation & Configuration",
                "Introduction to Networking",
                "PC Maintenance & Troubleshooting"
            ]
        },
        {
            "module": "Module 4: Programming & Database",
            "topics": [
                "Basics of Programming (C Language)",
                "Introduction to Algorithms & Flowcharts",
                "SQL & Database Concepts",
                "Mini Project"
            ]
        }
    ],
    "tools": [
        "Windows",
        "MS Office Suite",
        "MS Access",
        "Paint/Canva",
        "C Compiler",
        "SQL"
    ],
    "whatYouLearn": [
        "Work effectively with MS Office applications",
        "Use the internet and email for professional communication",
        "Perform computer hardware setup and troubleshooting",
        "Understand basic networking and database management",
        "Write simple programs in C",
        "Apply IT skills in real-world projects"
    ],
    "whoCanEnroll": [
        "Beginners looking to build computer skills",
        "Students preparing for office or IT jobs",
        "Professionals who want to improve digital literacy",
        "Small business owners managing office work",
        "Anyone interested in learning the basics of IT"
    ],
    "careerPaths": [
        "Computer Operator",
        "Office Executive",
        "Data Entry Operator",
        "Technical Support Assistant",
        "Junior IT Staff"
    ],
    "testimonials": [
        {
            "name": "Anjali Mehta",
            "role": "Data Entry Operator",
            "content":
                "DCA helped me build confidence in MS Office and databases. I now manage office tasks with ease.",
            "rating": 5
        },
        {
            "name": "Suresh Kumar",
            "role": "Computer Operator",
            "content":
                "The course was very practical and beginner-friendly. It gave me the skills needed for my first IT job.",
            "rating": 4
        }
    ]
},
"hdca": {
    "title": "Honours Diploma in Computer Application (HDCA)",
    "description":
        "Master advanced computer applications with a comprehensive honours diploma. This program covers office tools, programming, database management, web development, and design skills to prepare you for professional IT careers.",
    "category": "Computer Application",
    "duration": "6 months",
    "level": "Beginner to Advanced",
    "students": "350+",
    "rating": 4.7,
    "price": "₹35,000",
    "whatIsCourse":
        "The Honours Diploma in Computer Application (HDCA) is a career-oriented course designed to provide in-depth knowledge of computer applications. It builds upon fundamental skills and advances into programming, web development, database management, graphic design, and IT troubleshooting. With real-world projects and hands-on training, learners are equipped for both technical and creative roles in the IT industry.",
    "image":
        "https://img.freepik.com/free-photo/software-developer-coding-computer-screen_23-2148819975.jpg",
    "syllabus": [
        {
            "module": "Module 1: Computer Fundamentals & Office Tools",
            "topics": [
                "Computer Basics & Windows OS",
                "MS Word, Excel, PowerPoint (Advanced Features)",
                "MS Access & Database Management",
                "Internet & Email Applications"
            ]
        },
        {
            "module": "Module 2: Hardware & Networking",
            "topics": [
                "Computer Hardware & Configuration",
                "Installation & Maintenance",
                "Networking Concepts & LAN Setup",
                "Troubleshooting Techniques"
            ]
        },
        {
            "module": "Module 3: Programming & Software Development",
            "topics": [
                "C & C++ Programming",
                "Object-Oriented Programming Concepts",
                "Python Programming",
                "Java Programming Basics",
                "Mini Projects"
            ]
        },
        {
            "module": "Module 4: Database & Web Technologies",
            "topics": [
                "SQL & Database Design",
                "Web Development (HTML, CSS, JavaScript)",
                "Introduction to PHP & MySQL",
                "Dynamic Web Applications"
            ]
        },
        {
            "module": "Module 5: Graphic Design & Multimedia",
            "topics": [
                "CorelDraw for Vector Graphics",
                "Adobe Photoshop for Image Editing",
                "PageMaker/InDesign for Publishing",
                "Multimedia Basics (Audio/Video Editing)"
            ]
        },
        {
            "module": "Module 6: Advanced IT Applications",
            "topics": [
                "Cloud Computing Fundamentals",
                "Cybersecurity Awareness",
                "IT Project Management Basics",
                "Capstone Project (Integrating Multiple Skills)"
            ]
        }
    ],
    "tools": [
        "Windows & MS Office Suite",
        "C/C++ Compiler",
        "Python",
        "Java",
        "SQL/MySQL",
        "HTML, CSS, JavaScript",
        "PHP",
        "CorelDraw",
        "Photoshop",
        "PageMaker/InDesign"
    ],
    "whatYouLearn": [
        "Work professionally with advanced MS Office tools",
        "Troubleshoot and maintain computer hardware",
        "Develop programs in C, C++, Python, and Java",
        "Design and manage databases using SQL & MySQL",
        "Build static and dynamic websites",
        "Create professional graphics and DTP designs",
        "Understand basics of cybersecurity and cloud computing",
        "Complete real-world IT projects"
    ],
    "whoCanEnroll": [
        "Students aspiring for professional IT careers",
        "Graduates looking to upgrade technical skills",
        "Beginners who want to advance beyond DCA/PDCA",
        "Job seekers in IT support, programming, or design",
        "Entrepreneurs wanting digital and IT expertise"
    ],
    "careerPaths": [
        "Software Developer (Entry-Level)",
        "Web Developer",
        "Database Assistant",
        "IT Support Specialist",
        "Graphic & Multimedia Designer",
        "System Administrator (Junior Level)"
    ],
    "testimonials": [
        {
            "name": "Priya Nair",
            "role": "Web Developer",
            "content":
                "The HDCA course gave me a strong foundation in programming and web development. I built my first real-world projects here.",
            "rating": 5
        },
        {
            "name": "Arun Mishra",
            "role": "IT Support Specialist",
            "content":
                "From hardware troubleshooting to advanced IT skills, HDCA prepared me for multiple job roles. The hands-on approach was very effective.",
            "rating": 4
        }
    ]
},


    //tally
    "tally": {
        "title": "Tally.ERP 9",
        "description":
            "Master Tally.ERP 9 to handle accounting, inventory, taxation, payroll, and business management with ease.",
        "category": "Tally",
        "duration": "45 Days",
        "level": "Beginner to Intermediate",
        "students": "850+",
        "rating": 4.8,
        "price": "₹15,000",
        "whatIsCourse":
            "The Diploma in Tally.ERP 9 is designed to provide comprehensive knowledge of one of the most widely used accounting software in businesses today. The course covers fundamental and advanced topics including accounting, inventory management, GST, payroll, and reporting. Learners gain practical experience in managing real-time business scenarios such as billing, bank reconciliation, and point-of-sale operations. By the end of the course, students will be equipped to manage complete financial and business operations using Tally.ERP 9.",
        "image":
            "https://anjalicomputereducation.com/assets/anjali/course/tally-erp9.jpg",
        "syllabus": [
            {
                "module": "Module 1: Fundamentals of Accounting in Tally",
                "topics": [
                    "Introduction to Tally.ERP 9",
                    "Company Creation & Configuration",
                    "Basic Accounting in Tally",
                    "Bill-Wise Accounting"
                ]
            },
            {
                "module": "Module 2: Inventory & Sales Management",
                "topics": [
                    "Inventory Creation & Tracking",
                    "Batch-Wise Details",
                    "Point of Sales (POS)",
                    "Sales & Purchase Vouchers"
                ]
            },
            {
                "module": "Module 3: Taxation & Payroll",
                "topics": [
                    "GST Setup & Configuration",
                    "GST Transactions (Sales, Purchases, Returns)",
                    "Payroll Management in Tally",
                    "Salary Processing & Reports"
                ]
            },
            {
                "module": "Module 4: Advanced Features",
                "topics": [
                    "Bank Reconciliation (BRS)",
                    "Multi-Currency & Multi-Language Support",
                    "Generating Financial Reports",
                    "Capstone Project: Business Accounting Simulation"
                ]
            }
        ],
        "tools": [
            "Tally.ERP 9",
            "MS Excel (for reports)",
            "GST Compliance Tools"
        ],
        "whatYouLearn": [
            "Perform accounting operations in Tally.ERP 9",
            "Manage bill-wise and batch-wise details",
            "Handle inventory and POS billing",
            "Set up and apply GST in real-time business",
            "Process payroll and generate salary reports",
            "Perform bank reconciliation",
            "Work with multi-language and multi-currency features"
        ],
        "whoCanEnroll": [
            "Commerce and accounting students",
            "Small business owners",
            "Aspiring accountants",
            "Finance and tax professionals",
            "Job seekers in accounting domain"
        ],
        "careerPaths": [
            "Tally Operator",
            "Accountant",
            "Inventory Manager",
            "GST Practitioner",
            "Payroll Executive",
            "Finance Executive"
        ],
        "testimonials": [
            {
                "name": "Rohit Sharma",
                "role": "Accountant at SmallBiz Pvt Ltd",
                "content":
                    "Tally.ERP 9 training made accounting so much easier. I was able to apply what I learned directly in my job.",
                "rating": 5
            },
            {
                "name": "Nisha Verma",
                "role": "Payroll Executive",
                "content":
                    "The GST and payroll modules were extremely useful. The course was very practical and industry-focused.",
                "rating": 4
            }
        ]
    },
    //hardware
    "anplus": {
        "title": "Diploma in Hardware and Networking (A+N+)",
        "description":
            "Gain hands-on expertise in computer hardware, system maintenance, troubleshooting, and networking essentials. This course prepares you to manage, secure, and troubleshoot IT infrastructures effectively.",
        "category": "Hardware",
        "duration": "3 months",
        "level": "Beginner to Intermediate",
        "students": "700+",
        "rating": 4.7,
        "price": "₹18,000",
        "whatIsCourse":
            "The Diploma in Hardware and Networking (A+N+) provides learners with essential knowledge of computer hardware, operating systems, and networking technologies. This course covers computer assembling, maintenance, and troubleshooting techniques along with networking essentials like TCP/IP, DHCP, and Windows Server administration. Students will develop practical skills that prepare them for careers in IT support, networking, and system administration.",
        "image":
            "https://nctaindia.in/images/course/n.png",
        "syllabus": [
            {
                "module": "Module 1: Introduction to Computers",
                "topics": [
                    "Basics of Computers",
                    "Input, Output & Storage Devices",
                    "Understanding Operating Systems"
                ]
            },
            {
                "module": "Module 2: Hardware & System Assembly",
                "topics": [
                    "System Components & Peripherals",
                    "System Assembling & Configuration",
                    "BIOS Setup & Installation",
                    "Hardware Upgrading"
                ]
            },
            {
                "module": "Module 3: Maintenance & Troubleshooting",
                "topics": [
                    "Preventive Maintenance",
                    "Common Troubleshooting Techniques",
                    "Diagnosing System Errors",
                    "Repairing & Replacing Components"
                ]
            },
            {
                "module": "Module 4: Networking Essentials",
                "topics": [
                    "Basics of Computer Networks",
                    "Network Devices & Cabling",
                    "TCP/IP Fundamentals",
                    "DHCP Configuration"
                ]
            },
            {
                "module": "Module 5: Operating Systems & Servers",
                "topics": [
                    "Windows 7 Administration",
                    "Windows Server 1805 Configuration",
                    "User & Group Management",
                    "File Sharing & Permissions"
                ]
            }
        ],
        "tools": [
            "Computer Hardware Tools",
            "Windows 7",
            "Windows Server 1805",
            "Networking Devices",
            "Packet Tracer / Network Simulators"
        ],
        "whatYouLearn": [
            "Assemble and configure computer systems",
            "Maintain and troubleshoot hardware issues",
            "Install and configure operating systems",
            "Understand and apply networking essentials",
            "Configure TCP/IP and DHCP in networks",
            "Administer Windows 7 and Windows Server environments"
        ],
        "whoCanEnroll": [
            "Students aspiring for IT careers",
            "Hardware technicians",
            "Network support engineers",
            "System administrators",
            "IT support professionals"
        ],
        "careerPaths": [
            "IT Support Technician",
            "Hardware Engineer",
            "Network Technician",
            "System Administrator",
            "Technical Support Engineer"
        ],
        "testimonials": [
            {
                "name": "Ankit Mehra",
                "role": "System Support Engineer",
                "content":
                    "The A+N+ course gave me the confidence to build and troubleshoot PCs from scratch. Very practical and hands-on.",
                "rating": 5
            },
            {
                "name": "Pooja Iyer",
                "role": "Network Technician",
                "content":
                    "Networking fundamentals were explained in a simple way. The labs on TCP/IP and DHCP were especially helpful.",
                "rating": 4
            }
        ]
    },
    "autocad": {
        "title": "AutoCAD (Civil,Mechanical and Electrical)",
        "description":
            "Master AutoCAD tools and techniques for professional drafting, 2D/3D modeling, product design, and structural visualization. This course equips you with the skills to create precise engineering and architectural designs.",
        "category": "AutoCAD",
        "duration": "3 months",
        "level": "Beginner to Advanced",
        "students": "600+",
        "rating": 4.8,
        "price": "₹22,000",
        "whatIsCourse":
            "The AutoCAD Design course provides in-depth knowledge of drafting, modeling, and design using AutoCAD software. Learners will gain expertise in 2D and 3D drafting, plan and elevation design, structural layouts, interior and exterior design, and circuit drafting. This course is tailored for aspiring architects, engineers, and design professionals seeking to create accurate and efficient digital drawings.",
        "image":
            "https://wallpapers.com/images/hd/auto-c-a-d-software-logo-over-blueprints-j1fvx817r2sc2s6v-2.jpg",
        "syllabus": [
            {
                "module": "Module 1: Drafting Fundamentals",
                "topics": [
                    "Introduction to AutoCAD Interface",
                    "Drawing and Editing Tools",
                    "Precision Drawing Techniques"
                ]
            },
            {
                "module": "Module 2: Product & Industrial Design",
                "topics": [
                    "Creating Product Designs",
                    "Mechanical Drafting",
                    "Detailing Techniques"
                ]
            },
            {
                "module": "Module 3: Layer Settings & Management",
                "topics": [
                    "Layer Creation & Control",
                    "Text, Dimensions, and Annotations",
                    "Line Types and Properties"
                ]
            },
            {
                "module": "Module 4: Plans & Elevations",
                "topics": [
                    "2D Floor Plans",
                    "Elevation & Section Drawings",
                    "Site Layouts"
                ]
            },
            {
                "module": "Module 5: Structural Design",
                "topics": [
                    "Beam & Column Drafting",
                    "Foundation Drawings",
                    "Structural Layouts"
                ]
            },
            {
                "module": "Module 6: Interior & Exterior Design",
                "topics": [
                    "Interior Layout & Furnishing",
                    "3D Exterior Modeling",
                    "Lighting & Rendering"
                ]
            },
            {
                "module": "Module 7: Circuit Design",
                "topics": [
                    "Electrical Circuit Drafting",
                    "Wiring Diagrams",
                    "Electronic Schematics"
                ]
            }
        ],
        "tools": [
            "AutoCAD",
            "AutoCAD Architecture",
            "3D Modeling Tools",
            "Rendering Tools"
        ],
        "whatYouLearn": [
            "Draft 2D and 3D models in AutoCAD",
            "Design mechanical and product components",
            "Create detailed floor plans and elevations",
            "Develop structural layouts and designs",
            "Work with layers and annotations effectively",
            "Design interior and exterior spaces",
            "Draft circuit and wiring diagrams"
        ],
        "whoCanEnroll": [
            "Civil engineering students",
            "Architecture students",
            "Mechanical engineers",
            "Interior designers",
            "Construction professionals"
        ],
        "careerPaths": [
            "AutoCAD Designer",
            "Architectural Draftsman",
            "Structural Designer",
            "Interior & Exterior Designer",
            "Mechanical Drafting Engineer"
        ],
        "testimonials": [
            {
                "name": "Ravi Kulkarni",
                "role": "Architectural Draftsman",
                "content":
                    "The AutoCAD course helped me design professional plans and elevations quickly. Very industry-relevant content.",
                "rating": 5
            },
            {
                "name": "Sneha Verma",
                "role": "Interior Designer",
                "content":
                    "Loved the interior and exterior design modules. The practical exercises really prepared me for real projects.",
                "rating": 4
            }
        ]
    },

    //V&M
    "mdvm": {
        "title": "MDVM - Master Diploma in Visual & Animation",
        "description":
            "Become an expert in visual design, animation, and multimedia production with industry-standard tools. This master diploma equips learners with creative and technical skills to build careers in multimedia, animation, film editing, and VFX.",
        "category": "Visual&Animation",
        "duration": "12 months",
        "level": "Beginner to Advanced",
        "students": "400+",
        "rating": 4.8,
        "price": "₹55,000",
        "whatIsCourse":
            "The MDVM course covers the complete spectrum of animation and multimedia tools, including CorelDRAW, Photoshop, Premiere, Flash, and Dreamweaver, along with advanced 3D tools like 3D Studio Max, Character Studio, and Nuke X. Students gain hands-on training in animation, video editing, audio production, character design, and VFX for movies and digital media.",
        "image":
            "https://www.lincoln.ac.uk/media/responsive2017/images/course/coursebanner/Animation.jpg",
        "syllabus": [
            {
                "module": "Module 1: Introduction to Animation",
                "topics": [
                    "Basics of Animation Principles",
                    "2D vs 3D Animation",
                    "Industry Applications"
                ]
            },
            {
                "module": "Module 2: CorelDRAW",
                "topics": [
                    "Vector Graphic Design",
                    "Logo Creation",
                    "Illustrations & Layouts"
                ]
            },
            {
                "module": "Module 3: SoundForge",
                "topics": [
                    "Audio Editing & Mixing",
                    "Noise Reduction Techniques",
                    "Sound Effects Creation"
                ]
            },
            {
                "module": "Module 4: Adobe Photoshop",
                "topics": [
                    "Photo Editing & Retouching",
                    "Digital Painting",
                    "Visual Effects for Media"
                ]
            },
            {
                "module": "Module 5: Adobe Premiere",
                "topics": [
                    "Video Editing Workflow",
                    "Transitions & Effects",
                    "Color Grading & Export"
                ]
            },
            {
                "module": "Module 6: Nuke X",
                "topics": [
                    "Compositing Basics",
                    "3D Integration",
                    "VFX & Motion Tracking"
                ]
            },
            {
                "module": "Module 7: Flash",
                "topics": [
                    "2D Animation in Flash",
                    "Interactive Animations",
                    "Web Animation Projects"
                ]
            },
            {
                "module": "Module 8: Dreamweaver",
                "topics": [
                    "Web Design Basics",
                    "Responsive Layouts",
                    "Multimedia Integration"
                ]
            },
            {
                "module": "Module 9: 3D Studio Max",
                "topics": [
                    "3D Modeling & Texturing",
                    "Lighting & Rendering",
                    "Animation in 3D Space"
                ]
            },
            {
                "module": "Module 10: Character Studio",
                "topics": [
                    "Character Rigging",
                    "Facial Expressions",
                    "Character Animation Workflow"
                ]
            }
        ],
        "tools": [
            "CorelDRAW",
            "SoundForge",
            "Adobe Photoshop",
            "Adobe Premiere",
            "Nuke X",
            "Adobe Flash",
            "Dreamweaver",
            "3D Studio Max",
            "Character Studio"
        ],
        "whatYouLearn": [
            "Master 2D and 3D animation principles",
            "Create vector-based designs and illustrations",
            "Edit and mix audio professionally",
            "Perform advanced photo editing and digital painting",
            "Edit videos with transitions, effects, and grading",
            "Work with VFX and compositing in Nuke X",
            "Build interactive Flash animations",
            "Design multimedia-rich web layouts",
            "Develop 3D models, animations, and renders",
            "Animate characters using Character Studio"
        ],
        "whoCanEnroll": [
            "Aspiring animators",
            "Graphic designers",
            "Video editors",
            "VFX artists",
            "Students interested in multimedia careers"
        ],
        "careerPaths": [
            "2D/3D Animator",
            "Graphic Designer",
            "Video Editor",
            "Compositing Artist",
            "VFX Specialist",
            "Multimedia Designer"
        ],
        "testimonials": [
            {
                "name": "Ananya Gupta",
                "role": "3D Animator",
                "content":
                    "The MDVM course gave me hands-on experience with 3D Studio Max and Character Studio. I feel confident working on animation projects now.",
                "rating": 5
            },
            {
                "name": "Karan Mehta",
                "role": "Video Editor",
                "content":
                    "Learning Adobe Premiere and Nuke X really boosted my editing and VFX skills. Highly recommended for creative learners.",
                "rating": 4
            }
        ]
    }

};
